import { useState } from "react";
import { isGuid } from "../../../Helpers";
import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import { GlobalConstants } from "../../constants/GlobalConstants";
import { FeatureFlags } from "../../constants/LocalServerConstants";
import { FieldTypes } from "../../interfaces/Global";
import BCModal from "../../ui/BCModal";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";

const MainTable = () => {
  const [isLoanTransactionModalOpen, setIsLoanTransactionModalOpen] =  useState(false);
  const [lateFeeId, setLateFeeId] =  useState("");
  const actionsButtons = ["add", "export"];
  const handleCloseModal = (): void => {
    setIsLoanTransactionModalOpen(false);
  };

  const handleYearMonthClick = ({ clickedRow }) => {
    setLateFeeId(clickedRow?.id);
    setIsLoanTransactionModalOpen(true);
  };
 
  return (
    <>
      <LmsTable
        title="Late Fee Transaction"
        actionButtons={actionsButtons}
        apiSuffix="latefeetransaction/late-fee-transactions"
        handleClick={handleYearMonthClick}
        columnLabelsDictionary={{
          yearMonth: "Year/Month",
        }}
        columnClickOptions={{
          yearMonth: {
            isModalContentLink: true,
            idProp: "id",
          },
        }}
        useApiFiltering
      />
      <BCModal
        closeIcon
        isModalOpen={isLoanTransactionModalOpen}
        onClose={handleCloseModal}
        content={
          <LmsTable
            title="Loan Transaction"
            apiSuffix={`latefeetransaction/${lateFeeId}/loan-transactions`}
            actionButtons={["export"]}
            columnLabelsDictionary={{
              apiece: "A Piece",
              bpiece: "B Piece",
              transactionEffectiveDate: "Effective Date",
              borrowerOrganization: "Borrower",
              lppayment: "LP Payment",
              nwccdateInspected: "Inspection Compnay Date Inspected",
              loan: "Loan #",
              notionalBpiece: "Notional Bpiece",
              outOfPocket: "Out Of Pocket(BC)",
            }}
            skipClick
          />
        }
        size="fullscreen"
      />
    </>
  );
};

const lateFeeTransactionsFields = (myForm: BCFormController) => {
  myForm.addCenteredGroup([
    myForm.getLabelField("Loan Selection", { width: 2, required: true }),
    myForm.getGroupRadioField("All Loans", { value: "AllLoans" }),
    myForm.getGroupRadioField("Selected Loans", { value: "SelectedLoans" }),
  ], { radioGroupName: "loanOption", radioGroupValue: "AllLoans" });

  myForm.addCenteredGroup([
     myForm.getLabelField(" ", { labelWarningText:"Please select the status(es) for which Late Fee should be generated." }),
  ], { isHidden: { loanOption: "SelectedLoans" }});

  myForm.addCenteredGroup([myForm.getDropdownField("Loan Status", "metadata/list-loan-statuses", {
    dropdownMultiple: true,
    required: true,
    name: "LoanStatusIds",
  })],{ isHidden: { loanOption: "SelectedLoans" } });
  
  myForm.addCenteredGroup([myForm.getDropdownField("Loan", "latefeetransaction/list-loans?fundId=&loanOption=AllLoans", {
    dropdownMultiple: true,
    required: true,
    name: "LoanIds"
  })], { isHidden: { loanOption: "AllLoans" }} );

    myForm.addCenteredGroup(
      [
        myForm.getDropdownField("Funds", "latefeetransaction/list-fund-orgs", {
          name: "fundId",
          required: true,
        }),
      ],
      { isHidden: { loanOption: "SelectedLoans" } }
    );

  myForm.addCenteredGroup([
    myForm.getLabelField("Owner Selection", { width: 2 }),
    myForm.getGroupRadioField("All Owners", { value: "AllOwners" }),
    myForm.getGroupRadioField("Selected Owner", { value: "SelectedOwner" }),
  ], { radioGroupName: "OwnerOption", radioGroupValue: "AllOwners" });

  myForm.addCenteredGroup(
    [
      myForm.getDropdownField("Loan Owner", "metadata/list-loan-company-orgs", {
        name: "OwnerOrganizationId",
        required: true,
      }),
    ],
    { isHidden: { OwnerOption: "AllOwners" } }
  );

  myForm.addCenteredGroup([myForm.getInputField("Year/Month", { name: "YearMonth", fieldType: GlobalConstants.InputTypes.YEAR_MONTH as FieldTypes, required: true })]);
  myForm.addCenteredGroup([myForm.getCalendarField("As On Date", { required: true })]);
  myForm.addCenteredGroup([myForm.getTextareaField("Description")]);

  return myForm;
};

const tableFormFields = (myForm: BCFormController, lateFeeTemplatesdata=[] as any, handleClick: string | ((arg0?: any) => any) | undefined) => {
  myForm.addCenteredGroup([
    myForm.getButtonField("Apply", handleClick),
    myForm.getButtonField("Close"),
    myForm.getCalendarField("Effective Date", { width: 2, required: true }),
    myForm.getInputField("Year/Month", { name: "yearMonth", width: 3, fieldType: GlobalConstants.InputTypes.YEAR_MONTH as FieldTypes, required: true }),
    myForm.getCalendarField("As On Date", { width: 2, required: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getCheckboxField("Yes/No", { inline: true, width: 3 }),
    myForm.getLabelField("Loan", {  width: 3 }),
    myForm.getLabelField("Borrower", { width: 3 }),
    myForm.getLabelField("Transaction Type", { width: 3 }),
    myForm.getLabelField("Late Fee", { position: "center", width: 3 }),
  ], { widths: 1 });

  if (lateFeeTemplatesdata?.lateFeeTransactionTempDetails) {
    lateFeeTemplatesdata?.lateFeeTransactionTempDetails.slice(0,20).map((
      {
        id,
        loanDisplay,
        borrowerOrganizationDisplay,
        transactionTypeDisplay,
        lateFeeAmount,
        applyLateFeeOption

      }: any, i: any) => {
      myForm.addCenteredGroup([
        myForm.getGroupRadioField("Yes", { name: "applyLateFeeOption", nestedInputsProp: i, width: 1 }),
        myForm.getGroupRadioField("No", { name: "applyLateFeeOption", nestedInputsProp: i, width: 1 }),
        myForm.getLabelField(loanDisplay || "", { width: 3,  position: "center" }),
        myForm.getLabelField(borrowerOrganizationDisplay || "", { width: 3, position: "center" }),
        myForm.getLabelField(transactionTypeDisplay || "", { width: 3, position: "center" }),
        myForm.getCurrencyField("lateFeeAmount", { label: "", name: "lateFeeAmount", value: lateFeeAmount, nestedInputsProp: id,  width: 3 }),
      ], { widths: 1, radioGroupName: `applyLateFeeOption${i}`, radioGroupValue: applyLateFeeOption  });
    });
  }

  return myForm;
};

const AddLateFeeTransactionsForm = () => {
  const [lateFeeTemplatesdata, setLateFeeTemplatesdata] = useState([] as any);
  const [isSuccess, setIsSuccess] = useState(false);
  const [inputCopy, setInputCopy] = useState([] as any);
  const [{ fetchData }] = useFetchData();

  const onSubmitSuccess = async(responseData, options) => {
    const resultId = responseData && isGuid(responseData) ? responseData : responseData?.id;
    const { data }  = await fetchData(`latefeetransaction/temp/${resultId}`);
    if(FeatureFlags.IS_DEBUG) {
      console.log(data?.lateFeeTransactionTempDetails); // Get second form and table
    }

    setLateFeeTemplatesdata(data);
    setIsSuccess(true);
    setInputCopy({...options?.inputs, id: resultId, effectiveDate : options?.inputs?.effectiveDate });
  };

  const handleClick = (options) => {
    options.handleSubmit("latefeetransaction", {
      method: "PUT",
       ...inputCopy,
      showSuccessUiMessage: true,
      buttonText: options.buttonText,
    });
  };

  const myForm = lateFeeTransactionsFields(new BCFormController({}, { submitSuffix: "latefeetransaction", blankWidth: 4, onSubmitSuccess }));
  const tableForm = tableFormFields(new BCFormController(lateFeeTemplatesdata, { blankWidth: 3 }), lateFeeTemplatesdata, handleClick);
  const formActions = [{ text: "Submit", action: "save" }, "close"];
  return (
    <>
      {!isSuccess && <LmsFormGenerator myForm={myForm} actions={formActions} />}
      {isSuccess && <LmsFormGenerator myForm={tableForm} actions={formActions} skipActions />}
    </>
  );
};

const LmsAccountingLateFeeTransactions = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (<>
    {isMainPage && <MainTable />}
    {isAdd && <AddLateFeeTransactionsForm />}
  </>);
};

export default LmsAccountingLateFeeTransactions;